import React, { useState, useEffect, useMemo } from "react";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import { emitTagChange } from "../helper/tagFilterCallbackStore";

interface AccountItem {
  [key: string]: any;
}

interface ExtendedGridFilterCellProps extends GridFilterCellProps {
  data?: AccountItem[];
  filterDescriptor?: {
    gridData?: AccountItem[];
    [key: string]: any;
  };
}

const CheckboxFilterCell: React.FC<ExtendedGridFilterCellProps> = (props) => {
  const { onChange, data, field, value, filterDescriptor } = props;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  useEffect(() => {
    if (typeof value === "string") {
      setSelectedValues([value]);
    } else if (Array.isArray(value)) {
      setSelectedValues(value);
    } else {
      setSelectedValues([]);
    }
  }, [value]);

  const allValues = useMemo(() => {
    const valueSet = new Set<string>();
    const source = data || filterDescriptor?.gridData || [];

    source.forEach((item) => {
      const fieldValue = item?.[field!];
      if (Array.isArray(fieldValue)) {
        fieldValue.forEach((val: string) => valueSet.add(val));
      } else if (typeof fieldValue === "string") {
        valueSet.add(fieldValue);
      }
    });

    return Array.from(valueSet).sort();
  }, [data, filterDescriptor?.gridData, field]);

  const handleValueChange = (val: string) => {
    const updated = selectedValues.includes(val)
      ? selectedValues.filter((v) => v !== val)
      : [...selectedValues, val];

    const cleaned = updated.filter((v) => !!v);

    setSelectedValues(cleaned);
    if (cleaned.length > 0) {
      // Send selected tags using the expected key name
      emitTagChange?.({ selectedTags: cleaned });

      onChange?.({
        value: cleaned.length === 1 ? cleaned[0] : cleaned,
        operator: "contains",
        syntheticEvent: {
          nativeEvent: new Event("change"),
        } as React.SyntheticEvent<any, Event>,
      });
    } else {
      emitTagChange({ selectedTags: [] });
      onChange?.({
        value: null,
        operator: "",
        syntheticEvent: {
          nativeEvent: new Event("change"),
        } as React.SyntheticEvent<any, Event>,
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        maxHeight: "300px",
      }}
    >
      <div style={{ overflowY: "auto", maxHeight: "250px" }}>
        {allValues.length > 0 ? (
          allValues.map((val) => (
            <div key={val} style={{ marginBottom: "4px" }}>
              <Checkbox
                checked={selectedValues.includes(val)}
                onChange={() => handleValueChange(val)}
                label={val}
              />
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", color: "#666", padding: "10px" }}>
            No values found
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckboxFilterCell;
